import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["href", "onClick"]
const _hoisted_2 = { class: "mb-3 flex justify-content-between" }
const _hoisted_3 = {
  key: 0,
  class: "text-900 font-medium text-xl"
}
const _hoisted_4 = {
  key: 1,
  class: "text-base font-medium col-12"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "mr-3 block mb-1"
}, "Name", -1)
const _hoisted_6 = { class: "mb-3 flex justify-content-between" }
const _hoisted_7 = {
  key: 0,
  class: "m-0 mb-4 p-0 text-600 line-height-3 mr-3"
}
const _hoisted_8 = {
  key: 1,
  class: "text-base font-medium col-12"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "description",
  class: "mr-3 block mb-1"
}, "Description", -1)
const _hoisted_10 = { class: "mb-3 flex justify-content-between" }
const _hoisted_11 = { class: "text-base font-medium col-12" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "text-900 font-medium text-l mb-1" }, "Campaign Status", -1)
const _hoisted_13 = {
  key: 0,
  class: "col-12"
}
const _hoisted_14 = { class: "surface-card p-4 shadow-2 border-round" }
const _hoisted_15 = { class: "grid formgrid p-fluid" }
const _hoisted_16 = { class: "field mb-4 col-12" }
const _hoisted_17 = {
  key: 0,
  class: "m-0 mb-4 p-0 text-600 line-height-3 mr-3"
}
const _hoisted_18 = {
  key: 1,
  class: "m-0 mb-4 p-0 text-600 line-height-3 mr-3"
}
const _hoisted_19 = { class: "font-bold text-lg text-cyan-800" }
const _hoisted_20 = {
  key: 2,
  class: "field"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  for: "phone",
  class: "font-medium mb-2"
}, "Phone Number", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "m-0 mb-4 pt-3 text-600 line-height-3 mr-3" }, "In order to send messages via your campaign, you will need to associate it with a phone number. If you have not yet purchased a phone number, that's okay! You can always come back and add it.", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", {
  class: "surface-100 mb-3 col-12",
  style: {"height":"2px"}
}, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "field mb-2 col-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-900 font-medium text-l mb-1" }, "Add Contacts"),
  /*#__PURE__*/_createElementVNode("p", { class: "m-0 mb-4 pt-3 text-600 line-height-3 mr-3" }, "Add your contacts now or come back and add them later.")
], -1)
const _hoisted_25 = { class: "field mb-4 col-12" }
const _hoisted_26 = {
  key: 0,
  class: "field mb-4 col-12"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", {
  class: "surface-100 mb-3 col-12",
  style: {"height":"2px"}
}, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "field mb-2 col-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-900 font-medium text-l mb-1" }, "Add Response Categories"),
  /*#__PURE__*/_createElementVNode("p", { class: "m-0 mb-4 pt-3 text-600 line-height-3 mr-3" }, "Specify how you would like responses to your campaign to be categorized. Simply add a label (e.g., \"Yes\" or \"No\".) You may add up to five categories.")
], -1)
const _hoisted_29 = { class: "field mb-4 col-12 md:col-2" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", {
  class: "surface-100 mb-3 col-12",
  style: {"height":"2px"}
}, null, -1)
const _hoisted_31 = { class: "field mb-2 col-12" }
const _hoisted_32 = { class: "grid" }
const _hoisted_33 = { class: "surface-card shadow-2 border-round p-4" }
const _hoisted_34 = { class: "flex border-bottom-1 surface-border pb-4" }
const _hoisted_35 = {
  class: "mr-3",
  style: {"width":"70px","height":"70px"}
}
const _hoisted_36 = { class: "flex flex-column align-items-start" }
const _hoisted_37 = { class: "text-xl text-900 font-medium mb-1" }
const _hoisted_38 = { class: "text-600 font-medium mb-2" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "bg-blue-50 text-blue-400 border-round inline-flex py-1 px-2 text-sm" }, "Active", -1)
const _hoisted_40 = { class: "flex justify-content-between pt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_spinner = _resolveComponent("spinner")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TabMenu = _resolveComponent("TabMenu")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_DynamicDialog = _resolveComponent("DynamicDialog")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_ScrollPanel = _resolveComponent("ScrollPanel")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading || _ctx.currentCampaignLoading || _ctx.phoneNumbersLoading || _ctx.contactsLoading || _ctx.categoriesLoading)
      ? (_openBlock(), _createBlock(_component_spinner, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_TabMenu, {
      activeIndex: _ctx.active,
      "onUpdate:activeIndex": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.active) = $event)),
      model: _ctx.tabItems,
      class: "mb-4"
    }, {
      item: _withCtx(({ item, props }) => [
        _createVNode(_component_router_link, {
          to: { name: item.route },
          custom: ""
        }, {
          default: _withCtx(({ href, navigate }) => [
            _withDirectives((_openBlock(), _createElementBlock("a", _mergeProps({ href: href }, props.action, { onClick: navigate }), [
              _createElementVNode("span", _normalizeProps(_guardReactiveProps(props.icon)), null, 16),
              _createElementVNode("span", _normalizeProps(_guardReactiveProps(props.label)), _toDisplayString(item.label), 17)
            ], 16, _hoisted_1)), [
              [_directive_ripple]
            ])
          ]),
          _: 2
        }, 1032, ["to"])
      ]),
      _: 1
    }, 8, ["activeIndex", "model"]),
    _createVNode(_component_ScrollPanel, { style: {"width":"100%","height":"78vh"} }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (!_ctx.editMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.currentCampaign?.name), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(_component_InputText, {
                  modelValue: _ctx.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event)),
                  id: "name",
                  type: "text",
                  style: {"width":"85%"}
                }, null, 8, ["modelValue"])
              ])),
          (!_ctx.editMode)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 2,
                onClick: _ctx.toggleEditMode,
                class: "mr-3",
                icon: "pi pi-pencil",
                rounded: ""
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (!_ctx.editMode)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.currentCampaign?.description), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_Textarea, {
                  modelValue: _ctx.description,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.description) = $event)),
                  id: "description",
                  type: "text",
                  style: {"width":"85%"}
                }, null, 8, ["modelValue"])
              ]))
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_Tag, {
              value: _ctx.currentCampaign?.status,
              severity: _ctx.isCampaignActive ? 'success' : 'secondary'
            }, null, 8, ["value", "severity"])
          ])
        ]),
        (_ctx.editMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(_component_Button, {
                onClick: _ctx.toggleEditMode,
                label: "Cancel",
                severity: "secondary",
                outlined: "",
                class: "w-auto mb-3 mr-3"
              }, null, 8, ["onClick"]),
              _createVNode(_component_Button, {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateCampaign())),
                disabled: !_ctx.name && !_ctx.description,
                label: "Update Campaign",
                class: "w-auto mb-3"
              }, null, 8, ["disabled"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              (!_ctx.editMode && !_ctx.currentCampaign?.phoneNumberId)
                ? (_openBlock(), _createElementBlock("p", _hoisted_17, " You have no phone number associated with this campaign. Please select one below or purchase a phone number. "))
                : (!_ctx.editMode && _ctx.currentCampaign?.phoneNumberId)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
                      _createTextVNode(" The phone number associated with this campaign is: "),
                      _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.findCampaignPhoneNumber()), 1)
                    ]))
                  : _createCommentVNode("", true),
              (!_ctx.currentCampaign?.phoneNumberId)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _hoisted_21,
                    _createVNode(_component_Dropdown, {
                      modelValue: _ctx.selectedPhoneNumber,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedPhoneNumber) = $event)),
                      options: _ctx.phoneNumberOptions,
                      optionLabel: "label",
                      optionValue: "value",
                      optionDisabled: "disabled",
                      filter: true,
                      filterBy: "label",
                      showClear: true
                    }, null, 8, ["modelValue", "options"]),
                    _createVNode(_component_Button, {
                      onClick: _ctx.associatePhoneNumber,
                      label: "Add Phone Number",
                      disabled: !_ctx.selectedPhoneNumber,
                      class: "w-auto mt-3"
                    }, null, 8, ["onClick", "disabled"]),
                    _hoisted_22
                  ]))
                : _createCommentVNode("", true)
            ]),
            _hoisted_23,
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_Button, {
                onClick: _ctx.openAddContactModal,
                icon: "pi pi-plus",
                rounded: ""
              }, null, 8, ["onClick"])
            ]),
            (_ctx.campaignContacts?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createVNode(_component_DataTable, {
                    editingRows: _ctx.editingRows,
                    "onUpdate:editingRows": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editingRows) = $event)),
                    value: _ctx.campaignContacts,
                    scrollable: "",
                    scrollHeight: "400px",
                    dataKey: "contactId",
                    editMode: "row",
                    onRowEditSave: _ctx.onRowEditSave
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Column, {
                        field: "name",
                        header: "Name",
                        sortable: ""
                      }, {
                        editor: _withCtx(({ data, field }) => [
                          _createVNode(_component_InputText, {
                            modelValue: data[field],
                            "onUpdate:modelValue": ($event: any) => ((data[field]) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "phoneNumber",
                        header: "Phone Number"
                      }, {
                        editor: _withCtx(({ data, field }) => [
                          _createVNode(_component_InputText, {
                            modelValue: data[field],
                            "onUpdate:modelValue": ($event: any) => ((data[field]) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        rowEditor: true,
                        style: {"width":"10%","min-width":"8rem"},
                        bodyStyle: "text-align: center"
                      }),
                      _createVNode(_component_Column, { bodyStyle: "width: 4rem; text-align: center;" }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_Button, {
                            icon: "pi pi-trash",
                            class: "p-button-rounded p-button-danger",
                            onClick: ($event: any) => (_ctx.confirmDeleteContact(slotProps.data.contactId))
                          }, null, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["editingRows", "value", "onRowEditSave"])
                ]))
              : _createCommentVNode("", true),
            _hoisted_27,
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_component_Button, {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openAddCategoryModal())),
                icon: "pi pi-plus",
                rounded: ""
              })
            ]),
            _hoisted_30,
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.campaignCategories, (category, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "col-12 md:col-6 xl:col-4 p-3"
                  }, [
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _createVNode(_component_Button, {
                            icon: "pi pi-filter",
                            rounded: ""
                          })
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("span", _hoisted_37, _toDisplayString(`Category ${index + 1}`), 1),
                          _createElementVNode("span", _hoisted_38, _toDisplayString(category.categoryLabel), 1),
                          _hoisted_39
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _createVNode(_component_Button, {
                          onClick: ($event: any) => (_ctx.confirmDeleteCategory(category.categoryId)),
                          label: "Delete",
                          icon: "pi pi-trash",
                          class: "p-button-outlined p-button-secondary w-6 mr-2"
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_Button, {
                          onClick: ($event: any) => (_ctx.openAddCategoryModal(category.categoryId, true)),
                          label: "Edit",
                          icon: "pi pi-search",
                          class: "p-button-outlined p-button-secondary w-6 ml-2"
                        }, null, 8, ["onClick"])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ]),
        _createVNode(_component_DynamicDialog),
        _createVNode(_component_ConfirmDialog)
      ]),
      _: 1
    })
  ], 64))
}